import { DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, ConfigProvider, Input, Pagination, Switch, Table, TableColumnsType } from 'antd';
import viVN from 'antd/locale/vi_VN';
import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../../../Layout';
import * as UnitApi from '../../../api/unit/unitApi';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import useToast from '../../../hook/useToast';
import ModalCreateArea from './Modal/ModalCreateArea';
import ModalEditArea from './Modal/ModalEditArea';
import './style.scss';
import useLoading from '../../../hook/useLoading';
import { checkDisabledPermission, dataPagination, getUserPermissions } from '../../../until';
import useDebounce from '../../../hook/useDebounce';
import DrawerAddvance from '../../VehicleManagement/VehicleList/Component/Drawer/DrawerAddvance';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { NodataTable } from '../../../components/NoDataTable';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { formatNumber } from '../../../services/mixin';

const Nationwide: React.FC = () => {
  const pushLoading = useLoading();
  const pushToast = useToast();
  const location = useLocation();
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, } = getUserPermissions(permissionSlice, location.pathname)

  const [openCreateArea, setOpenCreateArea] = useState(false);
  const [openEditArea, setOpenEditArea] = useState(false);
  const [openDeleteArea, setOpenDeleteArea] = useState(false);
  const [isOpenAddvance, setIsOpenAddvance] = useState(false);
  const [id, setId] = useState<number>();
  const [inForNationwide, setInForNationwide] = useState<UnitApi.INationwide>();
  const [dataNationwide, setDataNationwide] = useState<UnitApi.DataTypeNationwide[]>([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [search, setSearch] = useState<string>();

  // Initialize columns as state
  // Initialize columns as state - SỬA LẠI PHẦN NÀY
  let columnDefs = useMemo<ColDef<any>[]>(() => [
    {
      headerName: 'Hành động',
      field: 'action',
      colId: 'action',
      width: 180,
      resizable: false,
      suppressMovable: true,
      lockPosition: 'left',
      headerComponentParams: {
        template: '<span class="w-full flex items-center justify-center">Hành động</span>'
      },
      cellRenderer: (params: ICellRendererParams) => {
        const { key } = params.data;
        return (
          <div className="h-full d-flex align-center justify-center gap-10-px">
            <EditOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
              onClick={() => inForlNationwide(Number(key))}
            />
            <DeleteOutlined
              className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(isdelete)}`}
              onClick={() => {
                setOpenDeleteArea(true);
                setId(Number(key));
              }}
            />
          </div>
        );
      }
    },
    {
      headerName: 'Mã toàn quốc',
      field: 'codeArea',
      colId: 'codeArea',
      flex: 1,
    },
    {
      headerName: 'Tên',
      field: 'nameArea',
      colId: 'nameArea',
      flex: 1,
      sortable: true,
      comparator: (valueA: string, valueB: string) => {
        return valueA.length - valueB.length;
      }
    },
    {
      headerName: 'Trạng thái',
      field: 'status',
      colId: 'status',
      flex: 1,
      cellRenderer: (params: ICellRendererParams) => {
        const { key, view } = params.data;
        return (
          <div className="d-flex align-center gap-10-px"
          >
            <Switch
              disabled={!edit}
              defaultChecked={!!view}
              onChange={() => {
                updateActiveNationwide(Number(key));
              }}
              className="rs-switch rs-switch--sm"
            />
            <p className="font-medium fw-500 text-344054">
              {UnitApi.activeArray[view ? 1 : 0]}
            </p>
          </div>
        );
      }
    }
  ], [pagination]); // Chỉ các hàm setState

  const defaultColumnsShow = ['action', 'codeArea', 'nameArea', 'status'] as any;

  const inForlNationwide = async (id: number) => {
    const result = await UnitApi.detailNationwide(id);
    if (result?.status) {
      setOpenEditArea(true);
      setInForNationwide(result?.data);
    } else {
      pushToast(result?.message, 'warning');
    }
  };

  const gListNationwide = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true);
    const result = await UnitApi.getListNationwideV2(pageSize, pageCurent, search);
    if (result?.status) {

      setDataNationwide(convertData(result.data));
      setPagination({ current: pageCurent, total: result.total, pageSize });
    } else {
      pushToast(result?.message, 'error', 2000);
    }
    pushLoading(false);
  }, 500);

  const updateActiveNationwide = async (id: number) => {
    const result = await UnitApi.updateActiveNationwide(id);
    if (result?.status) {
      gListNationwide(pagination.current, pagination.pageSize);
      pushToast(result.message, 'success', 2000);
    } else {
      pushToast(result.message, 'error', 2000);
    }
  };

  const onSubmitFormEdit = (isSuccer: boolean, errorMessage?: string) => {
    if (isSuccer) {
      pushToast('Chỉnh sửa đơn vị thành công', 'success');
      setOpenEditArea(false);
      gListNationwide(pagination.current, pagination.pageSize);
    } else {
      pushToast(errorMessage, 'warning');
    }
  };

  const convertData = (data: UnitApi.INationwide[]) => {
    const convertData = data.map((item) => ({
      key: item.id,
      codeArea: item.code,
      nameArea: item.title,
      view: item.view,
    }));
    return convertData;
  };

  const handleDelete = async () => {
    if (id) {
      const result = await UnitApi.deleteActiveNationwide(id);
      if (result?.status) {
        gListNationwide(pagination.current, pagination.pageSize);
        setOpenDeleteArea(false);
        pushToast('Xóa đơn vị thành công!', 'success', 2000);
      } else {
        pushToast(result?.message, 'error', 2000);
      }
    }
  };

  const onPaginationChange = (current: number, pageSize: number) => {
    setPagination((prev) => ({ ...prev, current, pageSize }));
    gListNationwide(current, pageSize);
  };

  const checkedList = localStorage.getItem('nationwideListColums')
    ? JSON.parse(localStorage.getItem('nationwideListColums') as string)
    : [...defaultColumnsShow];

  // Sử dụng colId thay vì key
  const columnDefsWithVisibility = useMemo(() => {
    return columnDefs.map((item: any) => ({
      ...item,
      hide: !checkedList.includes(item.colId) // Sử dụng hide property của AG Grid
    }));
  }, [columnDefs, checkedList]);

  const handleCloseSetting = (value: any, isChange: boolean, reorderedColumns: any[]) => {
    if (isChange) {
      localStorage.setItem('nationwideListColums', JSON.stringify(value));
      const updatedColumns = reorderedColumns.map((col) => ({
        ...col,
        hidden: !value.includes(col.colId),
      }));
      // setColumnDefs(updatedColumns);

      columnDefs = updatedColumns
    }
    setIsOpenAddvance(false);
  };

  useEffect(() => {
    document.title = 'THACO AUTO CRM';
    gListNationwide();
  }, [search]);

  return (
    <Layout>
      <ModalCreateArea
        gListNationwide={gListNationwide}
        isOpen={openCreateArea}
        closeModal={() => setOpenCreateArea(!openCreateArea)}
      />
      <ModalEditArea
        isOpen={openEditArea}
        inForNationwide={inForNationwide}
        onSubmitFormEdit={onSubmitFormEdit}
        closeModal={() => setOpenEditArea(!openEditArea)}
      />
      <ModalDeleteManager
        isOpen={openDeleteArea}
        onConfirm={handleDelete}
        closeModal={() => setOpenDeleteArea(!openDeleteArea)}
        title="Bạn có chắc chắn xóa toàn quốc này"
        titleDelete="Xóa toàn quốc"
        content="Toàn quốc và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
      />
      <DrawerAddvance
        isOpen={isOpenAddvance}
        columns={columnDefs}
        defaultColumnsShow={defaultColumnsShow}
        localStorageValue="nationwideListColums"
        onClose={(value, isChange, reorderedColumns) => handleCloseSetting(value, isChange, reorderedColumns)}
        closeDrawer={() => setIsOpenAddvance(!isOpenAddvance)}
      />
      <Breadcrumb
        items={[
          {
            title: 'THACO AUTO CRM',
          },
          {
            title: <a href="/">Danh mục đơn vị</a>,
          },
          {
            title: 'Toàn quốc',
          },
        ]}
      />
      <div className="title-page">Toàn quốc</div>
      <div className="d-flex align-center gap-10-px pb-18-px">
        <p className="text-base font-medium text-344054 white-space-nowrap">Danh sách toàn quốc</p>
        <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-1 h-8 justify-between overflow-hidden">
          <Input
            placeholder="Tìm kiếm"
            className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="border-l-F2F4F7 h-full d-flex align-center">
            <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
          </div>
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          className={`rs-button rs-button--sm ${checkDisabledPermission(add)}`}
          onClick={() => setOpenCreateArea(true)}
        >
          Tạo mới
        </Button>
        <button
          className="border-EAECF0 bg-white rounded-2 w-8 h-8 shadow-btn-save"
          onClick={() => setIsOpenAddvance(true)}
        >
          <SettingOutlined className="text-sm text-344054" />
        </button>
      </div>
      <div className={`order-history-card__body custom-page-css flex flex-col flex-1 justify-between`}>
        <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
          <AgGridReact
            className="my-auto-height-grid" getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            rowData={dataNationwide}
            rowHeight={55}
            columnDefs={columnDefsWithVisibility}
            rowSelection={{ mode: 'multiRow' }}
            // rowSelection="multiple"
            overlayNoRowsTemplate={NodataTable}
            suppressDragLeaveHidesColumns={true}
          />

        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination showSizeChanger current={pagination.current} pageSize={pagination.pageSize} total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize,
                pagination.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}
            />
          </div>
        </ConfigProvider>
      </div>
    </Layout>
  );
};

export default Nationwide;
